





















import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class RecommendModal extends Vue {
  private close() {
    this.$emit('close')
  }
}
